import { render, staticRenderFns } from "./itemSpecific.vue?vue&type=template&id=4c56de36&scoped=true"
import script from "./itemSpecific.vue?vue&type=script&lang=js"
export * from "./itemSpecific.vue?vue&type=script&lang=js"
import style0 from "./itemSpecific.vue?vue&type=style&index=0&id=4c56de36&prod&lang=css"
import style1 from "./itemSpecific.vue?vue&type=style&index=1&id=4c56de36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56de36",
  null
  
)

export default component.exports